import React from "react"
import { useLoginContext } from "src/hooks/useLoginContext"
import { getLabel } from "src/modules/helper"
import { Event } from "src/openapi"

import { Box, Image, Typography } from "src/UILibrary"

type Props = {
  item: Event
  handleSelected: any
}

export const EventItem = ({ item, handleSelected }: Props) => {
  const { eventCategories } = useLoginContext()

  return (
    <Box
      sx={{
        p: "1.25rem  0.625rem",
        ":hover": { opacity: 0.8, cursor: "pointer" },
      }}
      onClick={() => handleSelected(item)}
    >
      <Image
        src={item.imageUrl as string}
        sx={{ height: 160, bgcolor: "divider" }}
        alt=""
        imageStyle={{ width: "100%", height: "100%" }}
      />
      <Box display="flex" my={1.25} alignItems="center">
        <Typography.Description
          color="textPrimary"
          lineHeight={1.25}
          mr={1.25}
          sx={{ fontFamily: "Noto Sans JP !important" }}
        >
          {item.startTime?.slice(0, 10)}
        </Typography.Description>
        <Typography.Description
          color="textPrimary"
          lineHeight={1.25}
          mr={1.25}
          sx={{ fontFamily: "Noto Sans JP !important" }}
        >
          {item.startTime?.slice(11, 16)}
        </Typography.Description>
        <Typography.Action
          color="textPrimary"
          sx={{
            borderRadius: 0,
            border: "1px solid",
            borderColor: "text.primary",
            fontWeight: 500,
            lineHeight: "1.25rem",
            px: "0.625rem",
            fontFamily: "Noto Sans JP !important",
          }}
        >
          {getLabel(eventCategories, item.categoryId as number)}
        </Typography.Action>
      </Box>
      <Typography.SubTitle
        color="textPrimary"
        lineHeight={1}
        fontWeight={500}
        sx={{
          fontFamily: "Noto Sans JP !important",
          display: "-webkit-box",
          overflow: "hidden",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: 2,
        }}
      >
        {item.title}
      </Typography.SubTitle>
    </Box>
  )
}
